// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3862 ? "1a258343" : chunkId) + "-" + {"84":"9c851162456435b3","3862":"f60c9e28d8434a5b","6069":"9c7b24d867088acf"}[chunkId] + ".js";
};